import React from 'react';
import { HugeiconsIcon } from '@hugeicons/react';
import { BedDoubleIcon } from '@hugeicons/core-free-icons';

function Bedroom(props) {
    const fill = props.fill;
    const className = props.className;
    const size = props.size;
    return (
        <HugeiconsIcon
            icon={BedDoubleIcon}
            className={className}
            color={fill}
            size={size}
        />
    )
}

export default Bedroom;